import { Component, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';

import { BaseDropdownComponent } from 'shared/dropdown/_base-dropdown.component';


@Component({
  moduleId: module.id,
  selector: 'price-sheets-dropdown',
  templateUrl: 'price-sheets-dropdown.component.html',
  styleUrls: ['price-sheets-dropdown.component.scss']
})
export class PriceSheetsDropdownComponent extends BaseDropdownComponent {

  @Input() alignmentRight: boolean = true;
  @Input() placeholder: string = 'Select';
  @Input() arrowColor: string = '';
  @Input() declare selectedItem: any;

  @Output() selectedItemChange = new EventEmitter<any>();

  get selectedTitle(): string {
    return _.get(this.selectedItem, 'price_sheet_name', this.placeholder)
      || _.get(this.selectedItem, 'price_sheet_number', this.placeholder);
  }

  onSelectedChange(selected: any) {
    this.selectItem(selected);
  }

  setActive(priceSheetNumber: any): void {
    const item = _.find(this.items, ['price_sheet_number', priceSheetNumber]);
    if (item) {
      this.selectItem(item);
    }
  }

  private selectItem(selected: any): void {
    this.selectedItem = selected;
    this.selectedItemChange.emit(selected);
  }
}
